import { error } from 'console';
import * as Yup from 'yup';
import getValidationErrors, { Errors } from '../../utils/getValidationErrors';

export const schema = Yup.object().shape({
  product: Yup.string().required('Informe o produto'),
  table: Yup.string().required('Informe a tabela'),
});

export const validator = async (data: {
  product: string;
  table: string;
}): Promise<void> => {
  await schema.validate(data, {
    abortEarly: false,
  });
};

export const getYupErrors = (err: unknown): Errors | null => {
  if (err instanceof Yup.ValidationError) return getValidationErrors(err);
  return null;
};
